<template>
    <div class="wrapper contact-page">
        <div class="page-header page-header-small" v-if="!headerSimple">
            <parallax class="page-header-image" v-bind:style="{ backgroundImage: 'url(' + mensaje('img1') + ')' }">
            </parallax>
        </div>
        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(200%,-300%); line-height: normal;">contactar.json->mensajes:img1</span>
        
        <div class="page-head2 page-header-mini" v-if="headerSimple" :style="{ marginBottom: `${logo_altura}px` }">
        </div>

        <div class="main">
            <div class="contact-content">
                <div class="container">
                    <div class="row">
                        <div class="col-md-5 ml-auto mr-auto">
                            <h2 class="title">{{mensaje('tit1')}}</h2><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(10%,-150%); width: 180px; line-height: normal;">contactar.json->mensajes:tit1</span>
                            <p class="description">{{mensaje('desc1')}}<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,20%); width: 180px; line-height: normal;">contactar.json->mensajes:desc1</span>
                                <br>
                                <br>
                            </p>
                            <form role="form" id="contact-form" method="post">
                                <label>{{mensaje('tit2')}}<span v-if="$store.state.editor==true" class="texto-editor2">contactar.json->mensajes:tit2</span></label>
                                <fg-input
                                        :placeholder="mensaje('placeholder2')"
                                        v-model="crm.nombre"
                                        addon-left-icon="now-ui-icons users_circle-08">
                                </fg-input>
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(70%,-150%); width: 200px; line-height: normal;">contactar.json->mensajes:placeholder2</span>

                                <label>{{mensaje('tit3')}}<span v-if="$store.state.editor==true" class="texto-editor2">contactar.json->mensajes:tit3</span></label>
                                <fg-input
                                        :placeholder="mensaje('placeholder3')"
                                        v-model="crm.email"
                                        addon-left-icon="now-ui-icons ui-1_email-85">
                                </fg-input>
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(70%,-150%); width: 200px; line-height: normal;">contactar.json->mensajes:placeholder3</span>
                                <label>{{mensaje('tit4')}}<span v-if="$store.state.editor==true" class="texto-editor2">contactar.json->mensajes:tit4</span></label>

                                <fg-input
                                        :placeholder="mensaje('placeholder4')"
                                        v-model="crm.telefono"
                                        addon-left-icon="now-ui-icons tech_mobile">
                                </fg-input>
                                <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(70%,-150%); width: 200px; line-height: normal;">contactar.json->mensajes:placeholder4</span>

                                <div class="form-group">
                                    <label>{{mensaje('tit5')}}<span v-if="$store.state.editor==true" class="texto-editor2">contactar.json->mensajes:tit5</span></label>
                                    <textarea v-model="crm.comentario" name="message" class="form-control" id="message" rows="6"></textarea>
                                </div>
                                
                                <div class="row">
                                    <div class="col-md-6">
                                        <n-checkbox v-model="crm.check">
                                            {{mensaje('tit6')}}<span v-if="$store.state.editor==true" class="texto-editor2">contactar.json->mensajes:tit6</span>
                                        </n-checkbox>
                                    </div>
                                    <div class="col-md-6">
                                        <n-button type="primary" round @click.native="enviacrm" class="pull-right">{{mensaje('boton1')}}</n-button><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(150%,150%); width: 180px; line-height: normal;">contactar.json->mensajes:boton1</span>
                                    </div>
                                </div>
                            </form>
                        </div>
                        
                        <modal :show.sync="dialogVisible" headerClasses="justify-content-center">
                          <h4 slot="header" class="title title-up">Muchas Gracias por Contactar</h4>
                          <p>Su informacion ha sido grabada correctamente. Nos pondremos en contacto.</p>
                          <template slot="footer">
                            <n-button type="primary" @click.native="dialogVisible = false">Cerrar</n-button>
                          </template>
                        </modal>
                        

                        <div class="col-md-5 ml-auto mr-auto mt-5">
                          
                          <info-section type="primary"
                                        icon="now-ui-icons location_pin" v-for="(oficina, index) in nosotros.oficinas" :key="index">
                              <h4 class="info-title">{{oficina.nombre}}</h4><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(20%,-120%); line-height: normal;">contactar.json->nosotros:oficinas[]:nombre</span>
                              <p> {{oficina.direccion}}<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-20%,-20%); line-height: normal;">contactar.json->nosotros:oficinas[]:direccion</span>
                                  <br> {{oficina.cp}} {{oficina.poblacion}}<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-20%,-20%); line-height: normal;">contactar.json->nosotros:oficinas[]:cp y poblacion</span>
                                  <br> {{oficina.provincia}}<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(20%,-20%); line-height: normal;">contactar.json->nosotros:oficinas[]:provincia</span>
                                  <br> {{oficina.telefono}}<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-20%,-20%); line-height: normal;">contactar.json->nosotros:oficinas[]:telefono</span>
                                  <br> {{oficina.horario}}<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-20%,-20%); line-height: normal;">contactar.json->nosotros:oficinas[]:horario</span>
                              </p>
                          </info-section>
                          
                        </div> 

                    </div>
                </div>
            </div>
        </div>
        <gmap-map
                id="map"
                class="big-map"
                :center="center"
                :zoom="16"
                :options="options"
                map-type-id="roadmap" v-if="renderComponent">
            <gmap-marker :position="center">
            </gmap-marker>
        </gmap-map>
        <span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(400%,-800%); line-height: normal;">contactar.json->nosotros:center:lat y lng</span>
    </div>
</template>
<script>
  import { Button, InfoSection, FormGroupInput, Checkbox, Modal } from '@/components';
  import {RUTA_BASE} from '@/constants'
  import {RUTA_PHP} from '@/constants'
  import axios from "axios"
  
  //import {API_KEY} from '@/constants'
  import Vue from 'vue'
  export default {
    name: 'contact-us',
    bodyClass: 'contact-page',
    components: {
      Modal,
      InfoSection,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      [Checkbox.name]: Checkbox,
    },
    data() {
      return {
        dialogVisible: false,
        renderComponent: false,
        mensajes: [],
        nosotros: {},
        entorno: '',
        headerSimple: false,
        logo_altura: 0,
        form: {
          firstName: '',
          email: '',
          phone: '',
          mensajes: []
        },
        crm: {
          nombre: '',
          email: '',
          comentario: '',
          telefono: '',
          check: false
        },
        center: {
            lat: 43.321485,
            lng: -3.012901
        },
        options: {
          styles: [{
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
              "color": "#e9e9e9"
            }, {
              "lightness": 17
            }]
          }, {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f5f5f5"
            }, {
              "lightness": 20
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 17
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 29
            }, {
              "weight": 0.2
            }]
          }, {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 18
            }]
          }, {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{
              "color": "#ffffff"
            }, {
              "lightness": 16
            }]
          }, {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f5f5f5"
            }, {
              "lightness": 21
            }]
          }, {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{
              "color": "#dedede"
            }, {
              "lightness": 21
            }]
          }, {
            "elementType": "labels.text.stroke",
            "stylers": [{
              "visibility": "on"
            }, {
              "color": "#ffffff"
            }, {
              "lightness": 16
            }]
          }, {
            "elementType": "labels.text.fill",
            "stylers": [{
              "saturation": 36
            }, {
              "color": "#333333"
            }, {
              "lightness": 40
            }]
          }, {
            "elementType": "labels.icon",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [{
              "color": "#f2f2f2"
            }, {
              "lightness": 19
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#fefefe"
            }, {
              "lightness": 20
            }]
          }, {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [{
              "color": "#fefefe"
            }, {
              "lightness": 17
            }, {
              "weight": 1.2
            }]
          }]

        }
      }
    },
    watch: {
      '$store.state.idioma': {
        handler(newValue, oldValue) {
          // Acciones a realizar cuando la variable cambia
          console.log('La variable ha cambiado', newValue)
          this.cambiaIdioma(newValue)
        },
        deep: true // Opcional: vigila cambios profundos en la variable
      },
    },
    methods: {
      
      cambiaIdioma(nuevoValor) {
        var numIdioma = this.$store.state.idiomas[nuevoValor]
        var cadJson = 'json/contactar'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
          this.mensajes = response.data.mensajes
          this.nosotros = response.data.nosotros
          this.center.lat = parseFloat(this.nosotros.center.lat)
          this.center.lng = parseFloat(this.nosotros.center.lng)
          console.log("nosotros: ",this.nosotros.center)
          this.renderComponent = true
        })
        .catch(error => console.log(error))
      },
      
        contratar() {
          this.$router.push('/contratar')
        },
        
        mensaje(nom) {
          var mens = ''
          this.mensajes.forEach(elemento => {
            if (elemento.nombre==nom) {
              mens = elemento.mensaje
            }
          })
          return(mens)
        },
        enviacrm() {
          if (this.crm.check==true) {
            var params = new URLSearchParams()
            params.append('nombre',this.crm.nombre)
            params.append('email', this.crm.email)
            params.append('comentario', this.crm.comentario)
            params.append('telefono', this.crm.telefono)
            axios.post(RUTA_PHP+'contactacrm.php', params)
            .then((respuesta) => {
                if (typeof respuesta.data !== 'undefined' && respuesta.data.length > 0) {
                  var resp = respuesta.data
                  console.log(resp)
                  if (resp.includes("CORRECTO")) {
                    console.log('correcto')
                    this.dialogVisible = true
                  }
                }
            });
          } else {
          }
        }
      },
      created() {
        
      },
      mounted() {
        this.entorno = process.env.NODE_ENV
        this.headerSimple = this.$store.state.header_simple
        this.logo_altura = this.$store.state.logo_altura
        console.log("IDIOMA CONTACTA: ",this.$store.state.idioma)
        var numIdioma = this.$store.state.idiomas[this.$store.state.idioma]
        var cadJson = 'json/contactar'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
            this.mensajes = response.data.mensajes
            this.nosotros = response.data.nosotros
            this.center.lat = parseFloat(this.nosotros.center.lat)
            this.center.lng = parseFloat(this.nosotros.center.lng)
            console.log("nosotros: ",this.nosotros.center)
            this.renderComponent = true
        })
        .catch(error => console.log(error))
      }
  }
</script>
<style>
</style>
